"use client";

import { useLayoutEffect } from "react";

/**
 * Puts the reader at the top of the page when a blog index page mounts.
 *
 * The site scrolls inside `#scroll-container`, not the window (see the
 * `[locale]` layout), and the router's own scroll-on-navigate does not land
 * there: going from the pagination bar at the foot of page 2 to page 3 used to
 * leave the reader ~800px down the new page, somewhere in the middle of the
 * grid. The pagination links opt out of the router's scroll (`scroll={false}`)
 * and this takes over.
 *
 * Rendered with `key={page}`, so it runs once per page rather than once per
 * visit. `instant` because the scrollport carries `scroll-behavior: smooth`,
 * which would otherwise turn the jump into a ride up past every card.
 *
 * A language switch is unaffected: LanguageProvider restores the offset in its
 * own layout effect, which runs after this one (parents after children).
 */
export function ScrollToTop() {
  useLayoutEffect(() => {
    document
      .getElementById("scroll-container")
      ?.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return null;
}
